export const OPTIONS_INIT_REQUEST = 'OPTIONS_INIT_REQUEST';
export const OPTIONS_INIT_SUCCESS = 'OPTIONS_INIT_SUCCESS';
export const OPTIONS_INIT_ERROR = 'OPTIONS_INIT_ERROR';
export const OPTIONS_UPDATE_MAX_MILAGE_SUCCESS = 'OPTIONS_UPDATE_MAX_MILAGE_SUCCESS';
export const OPTIONS_UPDATE_MIN_PRICE_SUCCESS = 'OPTIONS_UPDATE_MIN_PRICE_SUCCESS';
export const OPTIONS_UPDATE_MAX_PRICE_SUCCESS = 'OPTIONS_UPDATE_MAX_PRICE_SUCCESS';
export const OPTIONS_UPDATE_VEHICLE_CARD_TYPE_SUCCESS = 'OPTIONS_UPDATE_VEHICLE_CARD_TYPE_SUCCESS';
export const OPTIONS_UPDATE_RESULTS_PER_PAGE_SUCCESS = 'OPTIONS_UPDATE_RESULTS_PER_PAGE_SUCCESS';
